<script setup lang="ts">
import Field from './Field.vue';
import { fieldPropDefs, useFieldProps } from './props';
import Password from 'primevue/password';

const props = defineProps({
    feedback: {
        type: Boolean,
        default: false,
    },
    ...fieldPropDefs,
});
const emit = defineEmits(['update:modelValue']);
const { id, name, fieldProps, modelValue } = useFieldProps(props, emit);
</script>

<template>
    <Field v-bind="fieldProps">
        <Password
            v-bind="$attrs"
            v-model="modelValue"
            :name="name"
            :input-id="id"
            :input-class="props.inputClass"
            :input-style="props.inputStyle as object"
            :feedback="!!props.feedback"
            :required="props.required"
            class="field-input"
        />
    </Field>
</template>
